import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { withProps } from 'recompose';
import IconButton from './icon_button';

export default withProps(() => ({ IconComponent: ChevronRightIcon }))(
  IconButton
);
